import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const shipmonkSettings = defineIntegrationSettings({
  fields: {
    storeId: z.string().trim().min(1, "Store ID is required"),
    sandboxMode: z.boolean(),
    allowBlindReturnsFallback: z.boolean(),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
